import { render, staticRenderFns } from "./property-mapper.vue?vue&type=template&id=0187f2d4"
import script from "./property-mapper.vue?vue&type=script&lang=js"
export * from "./property-mapper.vue?vue&type=script&lang=js"
import style0 from "./property-mapper.vue?vue&type=style&index=0&id=0187f2d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports